import FieldMaxLengths from '../views/my-account/general/GeneralEdit/FieldMaxLengths';

const trimToMaxLength = (name) => name.trimStart().substring(0, FieldMaxLengths.NAME);

export default trimToMaxLength;
